import PropTypes from "prop-types"
import { IconButton } from "@mui/material"
import { Settings } from "@mui/icons-material"
import OPTooltip from "components/material/tooltip"

export default function SettingsButton({ onClick }) {
  return <OPTooltip title="Display preferences">
    <IconButton className="settings" onClick={onClick} size="large"><Settings /></IconButton>
  </OPTooltip>
}

SettingsButton.propTypes = {
  onClick: PropTypes.func.isRequired,
}
